import { render, staticRenderFns } from "./floating-interactive.vue?vue&type=template&id=6720aff6&"
import script from "./floating-interactive.vue?vue&type=script&lang=js&"
export * from "./floating-interactive.vue?vue&type=script&lang=js&"
import style0 from "./floating-interactive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports